import React, { useContext } from 'react';
export const defaultValue = {
    tabs: [],
};
export const TabsContext = React.createContext(defaultValue);
export const useTabsContext = () => useContext(TabsContext);
